import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { YurticiCargoService } from '../../../services/YurticiCargoService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { GetYurticiCargoListPagingAndFilterRequest, initialGetYurticiCargoListPagingAndFilterRequest } from '../../../models/request/yurticiCargo/GetYurticiCargoListPagingAndFilterRequest';
import { GetYurticiCargoListPagingAndFilterResponse, GetYurticiCargoListPagingAndFilterResponseData, GetYurticiCargoListPagingAndFilterResponseItem, initialGetYurticiCargoListPagingAndFilterResponseData } from '../../../models/response/yurticiCargo/GetYurticiCargoListPagingAndFilterResponse';
import YurticiCargoListFilters from './Components/YurticiCargoListFilters';
import { UpdatePoResponse } from '../../../models/response/yurticiCargo/UpdatePoResponse';
import { GetCountryListResponse, GetCountryListResponseData } from '../../../models/response/country/GetCountryListResponse';
import { CountryService } from '../../../services/CountryService';
import { ExportYurticiCargoListResponse } from '../../../models/response/yurticiCargo/ExportYurticiCargoListResponse';
import { DeleteYurticiCargoResponse } from '../../../models/response/yurticiCargo/DeleteYurticiCargoResponse';
import Box from '../../../components/Box';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { YES_NO_FILTER, PO_GUNCELLEME_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { ServiceService } from '../../../services/ServiceService';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { poEslesmeDegistiBildir, poGuncellemeDurumu, poGuncellemeIpucu } from '../../../helpers/poGuncellemeDurumu';

// "Eksik kaldı" sebepleri; backend YurticiTakipKurali.Sebep* ile birebir aynı olmalı.
const EKSIK_SEBEPLERI = [
    '15 gün içinde teslim edilmedi',
    '15 gün içinde faturası gelmedi',
    '15 gün içinde teslim edilmedi ve faturası gelmedi',
    '60 gün içinde teslim edilmedi',
];

const YurticiCargoList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Kargo Modülü > Yurtiçi Kargo > Siparişler"
    const pageVersion = "7";
    const [data, setData] = useState<GetYurticiCargoListPagingAndFilterResponseData>(initialGetYurticiCargoListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetYurticiCargoListPagingAndFilterRequest>(initialGetYurticiCargoListPagingAndFilterRequest)
    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Gönderi Kodu', name: 'shippingCode', order: 0, isVisible: true },
            { title: 'Bölüm', name: 'divisionName', order: 0, isVisible: true },
            { title: 'Po', name: 'poName', order: 0, isVisible: true },
            { title: 'Po Number', name: 'poNo', order: 0, isVisible: true },
            { title: 'Elle Güncellendi', name: 'isPoManual', order: 0, isVisible: true },
            { title: 'Eksik Kaldı', name: 'isIncomplete', order: 0, isVisible: true },
            { title: 'Eksik Kaldı Sebebi', name: 'incompleteReason', order: 0, isVisible: true },
            { title: 'Gönderen Müşteri Kodu', name: 'senderCustomerCode', order: 0, isVisible: true },
            { title: 'Gönderici', name: 'senderCustomerName', order: 0, isVisible: true },
            { title: 'Çıkış İl', name: 'senderCountyName', order: 0, isVisible: true },
            { title: 'Çıkış İlçe', name: 'senderDistrictName', order: 0, isVisible: true },
            { title: 'Alıcı Müşteri Kodu', name: 'receiverCustomerCode', order: 0, isVisible: true },
            { title: 'Alıcı', name: 'receiverCustomerName', order: 0, isVisible: true },
            { title: 'Teslim İl', name: 'receiverCountyName', order: 0, isVisible: true },
            { title: 'Teslim İlçe', name: 'receiverDistrictName', order: 0, isVisible: true },
            { title: 'Çıkış Birimi', name: 'exitUnitName', order: 0, isVisible: true },
            { title: 'Varış Birimi', name: 'arrivalUnitName', order: 0, isVisible: true },
            { title: 'Teslim Birimi', name: 'deliveryUnitName', order: 0, isVisible: true },
            { title: 'Belge No', name: 'documentNo', order: 0, isVisible: true },
            { title: 'Belge Tipi', name: 'documentTypeName', order: 0, isVisible: true },
            { title: 'Kargo Bölgesi', name: 'shippingRegionName', order: 0, isVisible: true },
            { title: 'Toplam Miktar (Adet)', name: 'totalQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Ağırlık', name: 'totalWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Desi', name: 'totalDesi', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Hacimsel Ağırlık', name: 'totalDetailVolumetricWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Kargo Statüsü', name: 'shippingStatusName', order: 0, isVisible: true },
            { title: 'Oluşturma Tarihi', name: 'shippingCreateDateStr', order: 0, isVisible: true },
            { title: 'Yükleme Tarihi', name: 'shippingLoadDateStr', order: 0, isVisible: true },
            { title: 'Teslim Tarihi', name: 'shippingDeliverDateStr', order: 0, isVisible: true },
            { title: 'Teslim Eden', name: 'shippingDeliverer', order: 0, isVisible: true },
            { title: 'Teslim Alan', name: 'shippingReceiver', order: 0, isVisible: true },
            { title: 'Kap Cinsi', name: 'potTypes', order: 0, isVisible: true },
            { title: 'T. Koli Sayısı', name: 'totalPackageCount', order: 0, isVisible: true },
            { title: 'T. Dosya Sayısı', name: 'totalFileCount', order: 0, isVisible: true },
            { title: 'Satış Fatura Durumu', name: 'saleInvoiceStatus', order: 0, isVisible: true },
            { title: 'Alış Fatura Durumu', name: 'purchaseInvoiceStatus', order: 0, isVisible: true },
            { title: 'Satış Fatura Toplamı', name: 'saleInvoiceTotalAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Alış Fatura Toplamı', name: 'purchaseInvoiceTotalAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Satış Fatura Numaraları', name: 'saleInvoiceNumbers', order: 0, isVisible: true },
            { title: 'Alış Fatura Numaraları', name: 'purchaseInvoiceNumbers', order: 0, isVisible: true },
            { title: 'Beklenen Gelir Toplamı', name: 'expectedIncomeTotals', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Beklenen Gider Toplamı', name: 'expectedOutcomeTotals', order: 0, isVisible: true, className: 'custom-text-right' },

            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * (filter.take ?? 0)
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    // Panodaki bir karttan gelindiyse liste o kartın filtresiyle açılır.
    const location = useLocation();
    const gelenFiltreler: ColumnFilterModel[] | undefined = (location.state as any)?.columnFilters;

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    // Liste zaten açıkken üst bardaki zile basılınca adres aynı kalıyor, ekran yeniden kurulmuyordu; filtre
    // uygulanmıyor ve tıklama "çalışmıyor" görünüyordu (05.10.2026). Artık her gelişte (location.key) gelen filtre
    // uygulanır. Filtresiz gelişte yalnız ilk açılışta veri çekilir (eski davranış).
    const ilkAcilis = useRef(true);

    useEffect(() => {
        if (gelenFiltreler && gelenFiltreler.length > 0)
            getData({ ...filter, columnFilters: gelenFiltreler, currentPage: 1, skip: 0 });
        else if (ilkAcilis.current)
            getData();

        ilkAcilis.current = false;
    }, [location.key])

    const deleteYurticiCargo = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.yurticiCargoId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteYurticiCargoResponse = await YurticiCargoService.deleteYurticiCargo(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateYurticiCargo = async (_id: string | undefined = undefined) => {
        navigate('/yurticicargo/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].yurticiCargoId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetYurticiCargoListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetYurticiCargoListPagingAndFilterResponse = await YurticiCargoService.getYurticiCargoListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);

            if (!trCountry) {
                var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setTrCountry(response2.data.length > 0 ? response2.data[0] : undefined)
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.yurticiCargoId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    /**
     * Faturası eksik kargoların numarasını Yurtiçi'den tamamlar.
     * Tek seferde sınırlı sayıda kayıt işlenir; kalan varsa tekrar çalıştırılır.
     */
    const completeMissingInvoices = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response: any = await YurticiCargoService.completeMissingInvoices(200);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            toast.success(response.message);
            getData();
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var obj: GetYurticiCargoListPagingAndFilterRequest = buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.yurticiCargoId), columns);

            var response: ExportYurticiCargoListResponse = await YurticiCargoService.exportYurticiCargoList(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getColumnValue = (item: GetYurticiCargoListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.yurticiCargoId)} onDoubleClick={() => updateYurticiCargo(item.yurticiCargoId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.yurticiCargoId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (column == "isIncomplete") {
            // Sebebi ipucunda: "15 gün içinde teslim edilmedi" gibi.
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)} title={item.incompleteReason ?? undefined}><StatusBadge text={item.isIncomplete ? 'Evet' : 'Hayır'} /></td>;
        }
        else if (column == "isPoManual") {
            // Elle güncellenmiş (kilitli) kayıt: entegrasyon ve toplu PO güncellemesi bu satırın
            // Müşteri / Bölüm / PO / PO Numarası alanlarını değiştirmez.
            // "Otomatik": Gönderici - Alıcı Kayıtlı Değil tanımıyla sistem eşleştirdi (o da kilitli).
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)} title={poGuncellemeIpucu(item)}><StatusBadge text={poGuncellemeDurumu(item)} /></td>;
        }
        else if (column == "shippingStatusName" || column == "saleInvoiceStatus" || column == "purchaseInvoiceStatus") {
            // Durumlar renkli rozetle gösterilir (Teslim Edildi yeşil, Teslim edilemedi kırmızı vb.).
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)}><StatusBadge text={item2[column]} /></td>;
        }
        else if (['totalQuantity', 'totalWeight', 'totalDesi', 'totalDetailVolumetricWeight', 'saleInvoiceTotalAmount', 'purchaseInvoiceTotalAmount'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.yurticiCargoId)} onDoubleClick={!item.companyId ? undefined : () => updateYurticiCargo(item.yurticiCargoId)}>{item2[column]}</td>;
        }
    }

    const navigateToFindPrice = () => {
        var ids = data.items.filter(x => x.isSelected).map(x => x.yurticiCargoId);
        localStorage.setItem('SelectedIds', JSON.stringify(ids));
        navigate('/yurticicargo/listfindprice')
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Hesaplanan kolonlar (toplamlar,
    // fatura durumu, kap cinsi gibi) veritabanında karşılığı olmadığı için listede yok.
    const sortableColumns = [
        'refNo', 'shippingCode', 'poNo', 'isPoManual', 'isIncomplete', 'documentNo',
        'senderCustomerCode', 'receiverCustomerCode',
        'shippingDeliverer', 'shippingReceiver', 'incompleteReason',
        'totalPackageCount', 'totalFileCount',
        'shippingCreateDateStr', 'shippingLoadDateStr', 'shippingDeliverDateStr',
        'customerName', 'senderCustomerName', 'receiverCustomerName',
        'divisionName', 'poName'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (YurticiCargoManager.ApplyColumnFilters) aynı. Hesaplanan kolonların (toplamlar,
    // fatura numaraları, oluşturan/güncelleyen) filtresi yok.
    const loadList = async (request: Promise<any>, valueName: string, labelOf: (x: any) => string): Promise<ColumnFilterOption[]> => {
        const response = await request;

        if (!response.isSuccess)
            throw response.message;

        return (response.data ?? []).map((x: any) => ({ value: String(x[valueName]), label: labelOf(x) }));
    }

    const loadConstants = (code: string, parentId?: string) =>
        loadList(ConstantService.getConstantList(code, parentId), 'constantId', x => x.value);

    const loadUnits = () =>
        loadList(YurticiCargoService.getYurticiCargoUnitList(), 'id', x => `${x.countyName} - ${x.districtName} - ${x.name}`);

    const loadCounties = async () => {
        var country = trCountry;

        if (!country) {
            var response: GetCountryListResponse = await CountryService.getCountryList('TR');
            country = response.isSuccess && response.data.length > 0 ? response.data[0] : undefined;
        }

        return loadConstants('COUNTY', country?.countryId);
    }

    const invoiceStatusOptions = (noneText: string): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: '1', label: 'Faturalandı' },
        { value: '2', label: 'Kısmi Faturalandı' },
        { value: '3', label: 'Faturalanmadı' },
        { value: '4', label: noneText },
    ]);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        customerName: { type: 'text' },
        shippingCode: { type: 'text' },
        divisionName: { type: 'select', loadOptions: () => loadConstants('DIVISION') },
        poName: { type: 'select', loadOptions: () => loadList(ServiceService.getServiceList(true), 'serviceId', x => x.name) },
        poNo: { type: 'text' },
        // Elle güncellenen (kilitli) kayıtlar: entegrasyon ve toplu PO güncellemesi bu satırların
        // Müşteri / Bölüm / PO / PO Numarası alanlarını değiştirmez.
        isPoManual: PO_GUNCELLEME_FILTER,
        isIncomplete: YES_NO_FILTER,
        // Sebep metinleri backend'deki YurticiTakipKurali ile aynı; panodaki kartlar da bu metinlerle açılır.
        incompleteReason: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EKSIK_SEBEPLERI.map(x => ({ value: x, label: x }))) },
        senderCustomerCode: { type: 'text' },
        senderCustomerName: { type: 'text' },
        senderCountyName: { type: 'select', loadOptions: loadCounties },
        senderDistrictName: { type: 'text' },
        receiverCustomerCode: { type: 'text' },
        receiverCustomerName: { type: 'text' },
        receiverCountyName: { type: 'select', loadOptions: loadCounties },
        receiverDistrictName: { type: 'text' },
        exitUnitName: { type: 'select', loadOptions: loadUnits },
        arrivalUnitName: { type: 'select', loadOptions: loadUnits },
        deliveryUnitName: { type: 'select', loadOptions: loadUnits },
        documentNo: { type: 'text' },
        documentTypeName: { type: 'select', loadOptions: () => loadConstants('DOCUMENT_TYPE_YURTICI') },
        shippingRegionName: { type: 'select', loadOptions: () => loadConstants('SHIPPING_REGION_YURTICI') },
        shippingStatusName: { type: 'select', loadOptions: () => loadConstants('SHIPPING_STATUS_YURTICI'), renderOption: (label) => <StatusBadge text={label} /> },
        shippingCreateDateStr: { type: 'date' },
        shippingLoadDateStr: { type: 'date' },
        shippingDeliverDateStr: { type: 'date' },
        shippingDeliverer: { type: 'text' },
        shippingReceiver: { type: 'text' },
        totalPackageCount: { type: 'number' },
        totalFileCount: { type: 'number' },
        // Kap Cinsi: kargonun urunlerinden birinin kap cinsi (06.10.2026).
        potTypes: { type: 'select', loadOptions: () => loadConstants('POT_TYPE') },
        // Fatura durumunda "(Boş)" yok; boş karşılığı "Beklenen Gelir/Gider Yok" seçeneği.
        saleInvoiceStatus: { type: 'select', allowEmpty: false, loadOptions: () => invoiceStatusOptions('Beklenen Gelir Yok'), renderOption: (label) => <StatusBadge text={label} /> },
        purchaseInvoiceStatus: { type: 'select', allowEmpty: false, loadOptions: () => invoiceStatusOptions('Beklenen Gider Yok'), renderOption: (label) => <StatusBadge text={label} /> },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Beklenen gelir/gider
    // döviz bazında gelir ("1.250,00 TRY, 45,00 USD"); her döviz alt alta yazılır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (columnName == 'expectedIncomeTotals' || columnName == 'expectedOutcomeTotals') {
            var text = (columnName == 'expectedIncomeTotals' ? totals?.expectedIncomeTotals : totals?.expectedOutcomeTotals) ?? '';

            return (
                <td className={className}>
                    {text.split(', ').filter(x => x != '').map(x => <div>{x}</div>)}
                </td>
            );
        }

        if (columnName == 'saleInvoiceTotalAmount') {
            return <td className={className}>{Helpers.correctPrice(totals?.saleInvoiceTotalAmount ?? 0, 2)}</td>;
        }

        if (columnName == 'purchaseInvoiceTotalAmount') {
            return <td className={className}>{Helpers.correctPrice(totals?.purchaseInvoiceTotalAmount ?? 0, 2)}</td>;
        }

        return <td className={className}></td>;
    }

    const updatePo = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.yurticiCargoId);

            dispatch(storeActivityIndicator(true))

            var response: UpdatePoResponse = await YurticiCargoService.updatePo(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)
            poEslesmeDegistiBildir();

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <YurticiCargoListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    navigateToFindPrice={navigateToFindPrice}
                    updatePo={updatePo}
                    trCountry={trCountry}
                    deleteFunction={deleteYurticiCargo}
                    onSearchSubmit={onSearchSubmit}
                    completeMissingInvoices={completeMissingInvoices}
                    updateFunction={updateYurticiCargo}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2 px-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className="new-table-container">
                            <table className="ebbe-table-fill">
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>

                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => setItemSelected(item.yurticiCargoId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }

                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take ?? 0}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / (filter.take ?? 0))}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default YurticiCargoList;